import { render, staticRenderFns } from "./BlogContainerV2.vue?vue&type=template&id=d4e97622"
import script from "./BlogContainerV2.vue?vue&type=script&lang=js"
export * from "./BlogContainerV2.vue?vue&type=script&lang=js"
import style0 from "./BlogContainerV2.vue?vue&type=style&index=0&id=d4e97622&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports